// extracted by mini-css-extract-plugin
module.exports = {"textareafooter":"LongTextArea_textareafooter__2Q7DJ","textAreaField":"LongTextArea_textAreaField__jIOX-"};